/* Coming soon gallery rail: prev/next buttons, shown only when the rail overflows. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const track = root.querySelector('[data-lsoon-track]');
    const arrows = root.querySelector('[data-lsoon-arrows]');
    const prev = root.querySelector('[data-lsoon-prev]');
    const next = root.querySelector('[data-lsoon-next]');
    if (!track || !arrows) return;
    const step = () => {
      const item = track.querySelector('li');
      return item ? item.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    };
    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      arrows.hidden = max < 4;
      prev.disabled = track.scrollLeft < 4;
      next.disabled = track.scrollLeft > max - 4;
    };
    const go = (dir) => track.scrollBy({ left: dir * step(), behavior: reduce.matches ? 'auto' : 'smooth' });
    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  };
  const start = () => document.querySelectorAll('[data-lsoon-rail]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();
